/**
 * Implements local storage middleware
 */

import _ from "lodash"
import {
  ArrDepSorting,
  FlightTableTab,
  ISelectionState
} from "../containers/selectionSlice"
import { handleGetSelectionSliceInitValues } from "../containers/Support"

const OCS_PORTAL_NAMESPACE = "OCS_PORTAL"

export const save = (store) => (next) => (action) => {
  let result = next(action)
  const _state = store.getState()

  const userName: string = tryGetUserName(_state)

  if (
    userName !== null &&
    action.type !== "seasonData/logoutUser" &&
    action.type !== "seasonData/logonUser"
  ) {
    const key = OCS_PORTAL_NAMESPACE + "-" + userName.toUpperCase()

    const serializedState = JSON.stringify(
      _.omit(_state, [
        "appReducer",
        "notificationReducer",
        "transactionReducer"
      ])
    )
    localStorage.setItem(key, serializedState)
  }

  return result
}

export const load = () => {
  try {
    const key = OCS_PORTAL_NAMESPACE + "-DEFAULT"

    const serializedState = localStorage.getItem(key)

    if (serializedState === null) {
      return {
        selectionReducer: handleGetSelectionSliceInitValues()
      }
    } else {
      let _state = JSON.parse(serializedState)

      delete _state.appReducer
      delete _state.notificationReducer

      _state = checkMatch(_state)

      return _state
    }
  } catch (err) {
    return {}
  }
}

export const getSelectionSliceStorage = (userName: string) => {
  const key = OCS_PORTAL_NAMESPACE + "-" + userName.toUpperCase()

  const serializedState = localStorage.getItem(key)
  if (serializedState === null) {
    return handleGetSelectionSliceInitValues()
  } else {
    let _state = JSON.parse(serializedState)
    _state = checkMatch(_state)
    return _state.selectionReducer
  }
}

export const checkMatch = (checkState: ISelectionState) => {
  const _state = checkState
  initIfAbsent(_state, "selectionReducer")
  initIfAbsent(_state, "selectionReducer.airportSeasonsSelector", {
    season: "",
    countries: [],
    airports: [],
    useLocalTime: true,
    useICAOCode: false
  })
  initIfAbsent(_state, "selectionReducer.flightSelector", { value: {} })
  initIfAbsent(_state, "selectionReducer.slotAvailabilitySelector", {
    values: {}
  })
  initIfAbsent(_state, "selectionReducer.pages")
  initIfAbsent(_state, "selectionReducer.pagesHistory")
  initIfAbsent(_state, "selectionReducer.userSettings", {
    showOptionalFields: true,
    useSSIMVIew: true
  })
  initIfAbsent(_state, "selectionReducer.flightTableSelection", {
    chosenFlightTableTab: FlightTableTab.default,
    chosenArrDepSorting: ArrDepSorting.ArrDep
  })
  initIfAbsent(
    _state,
    "selectionReducer.flightTableSelection.chosenArrDepSorting",
    ArrDepSorting.ArrDep
  )
  initIfAbsent(_state, "selectionReducer.collapsedCards", {
    flightID: false,
    period: false,
    times: true,
    other: true,
    handling: false,
    checkboxes: true
  })
  return checkState
}

const tryGetUserName = (state): string => {
  if (state.appReducer != null && state.appReducer.userInfo != null) {
    const _userInfo = state.appReducer.userInfo
    if (_userInfo.loginName !== undefined) {
      return _userInfo.authenticated ? _userInfo.loginName : "default"
    } else {
      return null
    }
  } else {
    return null
  }
}

const initIfAbsent = (state, key: string, value?: any) => {
  if (!_.hasIn(state, key)) {
    const obj = realiseObject(key, value)
    state = _.merge(state, obj)
    //state[key] = value || {}
  }
}

function realiseObject(objectPath, objectInitialValue = {}) {
  function realiseObject_(objectPathArr, objectInProgress) {
    if (objectPathArr.length === 0) {
      return objectInProgress
    } else {
      return realiseObject_(objectPathArr.slice(1), {
        [objectPathArr[0]]: objectInProgress
      })
    }
  }
  return realiseObject_(objectPath.split(".").reverse(), objectInitialValue)
}
